import { getLanguage } from '@/utils/getValue';

// 20230829 为了方便理解翻译，key值采用中文。特殊入星期几这种由接口返回的key保持不变
const lg = getLanguage() || 'zh-cn';
export const languageMap = {
  'zh-cn': {
    Cardholder: '持卡人',
    Issuer: '发卡机构',
    Notes: '使用规则',
    Record: '查看使用记录',
    Network: '查看休息室网络',
    NetworkBankcomm: '查看休息室位置', //  channel=bankcomm 特殊显示
    Usebtn: '生成使用凭证',
    ExpiredBtn: '卡已过期',
    Expirydate: '有效日期',
    GuestVisits: '携伴点数',
    Classic: '点卡',
    Prestige: '年卡',
    Unlimited2: '无限制卡',
    CardholderVisit: '本人可用',
    Unlimited: '不限次',
    AccessLounge: '使用休息室',
    Name: name,
    AvailableVisits: '可用点数',
    AvailableVisits2: '可用人次',
    AvailableVisits3: '可用次数',
    RailSetMeal: '高铁列车餐食',
    OfferInfo: '优惠信息',
    ViewDetails: '查看详情',
    HotFood: '热食',
    Rule: '服务须知',
    Children: '儿童收费标准',
    Amenities: '设施',
    BoardingGate: '登机口',
    SetMealOption: '套餐内容',
    ServingTime: '供应时间',
    ViewFullMenu: '查看完整菜单',
    CreateUsebtn: '生成使用凭证',
    LimitTitle: '相关限制',
    LimitAirUse: '仅允许以下航班使用',
    LightTag: '亮点标签',
    Reminder: '温馨提示',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六',
    sunday: '星期日',
    noTips: '没有找到相关内容',
    去使用: '去使用',
    已过期: '已过期', // 20230829看git两年前也就是（2021年）就没有这个按钮文案，后来添加上去不知道对不对
    收起: '收起',
    展开: '展开',
    重置: '重置',
    确认: '确认',
    NoLoungeTip: '暂无符合条件的结果，以下为您重新推荐休息室',
    休息室: '休息室',
    贵宾休息室: '贵宾休息室',
    餐食体验厅: '餐食体验厅',
    航站楼: '航站楼',
    安检类型: '安检类型',
    筛选: '筛选',
    SPA: 'SPA休息室',
  },
  en: {
    Usebtn: 'To Use',
    OfferInfo: 'Offer Info',
    ViewDetails: 'View Details',
    HotFood: 'Hot Food',
    Rule: 'T&Cs',
    Amenities: 'Amenities',
    BoardingGate: 'BoardingGate',
    SetMealOption: 'Set Meal Option',
    ServingTime: 'Serving Time',
    ViewFullMenu: 'View Full Menu',
    CreateUsebtn: 'CONFIRM TO ACCESS LOUNGE',
    LimitTitle: 'Related restrictions',
    LimitAirUse: 'Only the following flights are allowed',
    LightTag: 'Highlight label',
    Children: 'Charging standard for children',
    ExpiredBtn: 'Expired',
    Reminder: 'Reminder',
    monday: 'monday',
    tuesday: 'tuesday',
    wednesday: 'wednesday',
    thursday: 'thursday',
    friday: 'friday',
    saturday: 'saturday',
    sunday: 'sunday',
    Cardholder: 'Cardholder',
    Issuer: 'Issuer',
    Notes: 'Notes',
    Record: 'My Visited Places',
    Network: 'View Lounge List',
    NetworkBankcomm: 'View lounge location',
    Expirydate: 'Expiry date',
    GuestVisits: 'Guests Visit(s)',
    Classic: 'Classic',
    Prestige: 'Prestige',
    Unlimited2: 'Unlimited',
    CardholderVisit: 'Cardholder Visit',
    Unlimited: 'Unlimited',
    AccessLounge: 'Access Lounge',
    AvailableVisits: 'Available Visit(s)',
    AvailableVisits2: 'Available Visit(s)',
    AvailableVisits3: 'Available Visit(s)',
    RailSetMeal: 'Rail Set Meal',
    noTips: 'No relevant content found',
    去使用: 'CONFIRM TO ACCESS LOUNGE',
    已过期: 'Expired',
    收起: 'Put',
    展开: 'Open',
    重置: 'Reset',
    确认: 'confirm',
    NoLoungeTip:
      'There are no eligible results for the time being. Here is your recommender of the lounge',
    休息室: 'Lounge',
    贵宾休息室: 'VIP Lounge',
    餐食体验厅: 'Restaurant Lounge',
    SPA: 'SPA',
    航站楼: 'Terminal',
    安检类型: 'Security inspection type',
    筛选: 'screen',
  },
};

const lgText = languageMap[lg] || languageMap['zh-cn'];
export default lgText;
